import Route from 'cio/routes/base';
import { ALLOWED_DATA_INDEX_TYPES } from 'cio/utils/data-index';

export default class TypeRoute extends Route {
  redirect() {
    let { type } = this.paramsFor(this.routeName);

    if (ALLOWED_DATA_INDEX_TYPES.includes(type)) {
      return;
    }

    this.router.transitionTo('data-index');
  }
}
